const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000"

export const LOGIN_URL = `${BASE}/login/`
export const LOGOUT_URL = `${BASE}/logout/`

export const READ_USERS_URL = `${BASE}/read_users`
export const ADD_USER_URL = `${BASE}/useradd`
export const EDIT_USER_URL = `${BASE}/useredit`
export const READ_USER_MODULES_URL = `${BASE}/user_modules`
export const USER_UPD_MODULES_URL = `${BASE}/user_upd_modules`
export const USER_RECEIVE_RESET_PSWD_URL = `${BASE}/user_receive_reset_pswd`
export const USER_SEND_RESET_PSWD_URL = `${BASE}/user_send_reset_pswd`

export const DOG_URL = `${BASE}/routes/dog`
export const DOG_SEARCH_URL = `${BASE}/routes/dog_search`
export const DOG_FEES_EDIT_URL = `${BASE}/routes/dog_fees_edit`
export const DOG_TAGS_URL = `${BASE}/routes/dog_tags`
export const DOG_TAGS_GENERATE_URL = `${BASE}/routes/dog_tags_generate`
export const DOG_TAGS_ASSIGN_URL = `${BASE}/routes/dog_tags_assign`
export const DOG_TAGS_STAFF_URL = `${BASE}/routes/dog_tags_staff`
export const CLIENT_USERS_URL = `${BASE}/routes/client_users`
export const DOG_AGENT_LIST_URL = `${BASE}/routes/dog_agent_list`
export const DOG_AGENT_ADD_URL = `${BASE}/routes/dog_agent_add`
export const DOG_AGENT_DEL_URL = `${BASE}/routes/dog_agent_delete`
export const DOG_TAGS_AUTO_ASSIGN_URL = `${BASE}/routes/dog_tags_auto_assign`
export const DOG_TAGS_UNASSIGN_URL = `${BASE}/routes/dog_tags_unassign`
export const DOG_TAGS_INVENTORY_SUMMARY_URL = `${BASE}/routes/dog_tags_inventory_summary`
export const DOG_TAGS_PURGE_URL = `${BASE}/routes/dog_tags_purge`
export const DOG_DEPUTY_ASSIGNMENTS_URL = `${BASE}/routes/dog_deputy_assignments`
export const DOG_TAG_SEARCH_URL = `${BASE}/routes/dog_tag_search`
export const DOG_NAME_SEARCH_URL = `${BASE}/routes/dog_name_search`
export const DOG_TAXPAYER_LOAD_URL = `${BASE}/routes/dog_taxpayer_load`
export const DOG_EMAIL_SEARCH_URL = `${BASE}/routes/dog_email_search`
export const DOG_PHONE_SEARCH_URL = `${BASE}/routes/dog_phone_search`
export const DOG_LICENSE_ADD_URL = `${BASE}/routes/dog_license_add`
export const DOG_LICENSE_UPDATE_URL = `${BASE}/routes/dog_license_update`
export const DOG_LICENSE_DELETE_URL = `${BASE}/routes/dog_license_delete`
export const DOG_TAG_ASSIGN_URL = `${BASE}/routes/dog_tag_assign`
export const DOG_TAG_REPLACE_URL = `${BASE}/routes/dog_tag_replace`

export const UPD_THEME_URL = `${BASE}/upd_theme`
export const UPD_TIMEOUT_URL = `${BASE}/upd_timeout`

export const TAXPAYER_URL = `${BASE}/routes/TAXPAYER`
export const TAXPAYER_ADD_URL = `${BASE}/routes/TAXPAYERadd`
export const TAXPAYER_EDIT_URL = `${BASE}/routes/Taxpayeredit`
export const TAXPAYER_SEARCH_URL = `${BASE}/routes/TAXPAYERsearch`
export const TAXPAYER_DELETE_URL = `${BASE}/routes/taxpayer_delete`

export const TRANSACTION_ADD_URL = `${BASE}/routes/transaction_add`
export const DASHBOARD_RECEIPTS_URL = `${BASE}/routes/dashboard_receipts`
export const DASHBOARD_STATS_URL = `${BASE}/routes/dashboard_stats`
export const DASHBOARD_DEPUTY_RANKING_URL = `${BASE}/routes/dashboard_deputy_ranking`
export const DASHBOARD_FARMS_URL = `${BASE}/routes/dashboard_farms`
export const RECEIPT_NEXT_URL = `${BASE}/routes/receipt_next`
export const KENNEL_REGISTER_URL = `${BASE}/routes/kennel_register`
export const KENNEL_REGISTRATIONS_URL = `${BASE}/routes/kennel_registrations`

export const DOG_RECEIPT_REPORT_URL = `${BASE}/reports/dog_receipt/preview`
export const KENNEL_CERTIFICATE_REPORT_URL = `${BASE}/reports/dog_kennel_certificate/preview`

export const FARM_OWNER_SECTION_STATUS_URL = `${BASE}/routes/farm_owner_section_status`
export const FARM_DISTRICT_LIST_URL = `${BASE}/routes/farm_district_list`
export const FARM_DISTRICT_MAP_NAME_URL = `${BASE}/routes/farm_district_map_name`
export const FARM_OWNER_SEARCH_URL = `${BASE}/routes/farm_owner_search`
export const FARM_OWNER_LOAD_URL = `${BASE}/routes/farm_owner_load`
export const FARM_OWNER_ADD_URL = `${BASE}/routes/farm_owner_add`
export const FARM_OWNER_EDIT_URL = `${BASE}/routes/farm_owner_edit`
export const FARM_APPLICATION_LOAD_URL = `${BASE}/routes/farm_application_load`
export const FARM_APPLICATION_SAVE_URL = `${BASE}/routes/farm_application_save`
export const FARM_APPLICATION_OPERATOR_SAVE_URL = `${BASE}/routes/farm_operator_save`
export const FARM_APP_SECTIONS_LOAD_URL = `${BASE}/routes/farm_sections_load`
export const FARM_APP_SECTIONS_SAVE_URL = `${BASE}/routes/farm_sections_save`
export const FARM_PARCEL_LOAD_URL = `${BASE}/routes/farm_parcel_load`
export const FARM_ROLL_FORWARD_URL = `${BASE}/routes/farm_roll_forward`
export const FARM_APPLICATION_DELETE_URL = `${BASE}/routes/farm_application_delete`
export const FARM_SECTION_REVIEWED_URL = `${BASE}/routes/farm_section_reviewed`
export const FARM_PRODUCTION_SAVE_URL = `${BASE}/routes/farm_production_save`
export const FARM_QUALIFICATION_SAVE_URL = `${BASE}/routes/farm_qualification_save`
export const FARM_BEES_SAVE_URL = `${BASE}/routes/farm_bees_save`
export const FARM_POULTRY_SAVE_URL = `${BASE}/routes/farm_poultry_save`
export const FARM_LIVESTOCK_SAVE_URL = `${BASE}/routes/farm_livestock_save`
export const FARM_CROPS_SAVE_URL = `${BASE}/routes/farm_crops_save`
export const FARM_HAY_PRODUCTION_SAVE_URL = `${BASE}/routes/farm_hay_production_save`
export const FARM_PARCEL_SAVE_ALL_URL = `${BASE}/routes/farm_parcel_save_all`

export const DMV_SEARCH_URL = `${BASE}/routes/dmv_search`
export const DMV_RECORD_URL = `${BASE}/routes/dmv_record`

export const MAINTENANCE_COUNTS_URL = `${BASE}/routes/maintenance_counts`
export const FARM_APPLICATIONS_PURGE_URL = `${BASE}/routes/farm_applications_purge`
export const DMV_RECORDS_PURGE_URL = `${BASE}/routes/dmv_records_purge`
export const TAXPAYERS_PURGE_URL = `${BASE}/routes/taxpayers_purge`

export const SHEEP_GOATS_READ_URL = `${BASE}/routes/sheep_goats_read`
export const SHEEP_GOATS_ADD_URL = `${BASE}/routes/sheep_goats_add`
export const SHEEP_GOATS_UPDATE_URL = `${BASE}/routes/sheep_goats_update`
export const SHEEP_GOATS_DATE_PAID_URL = `${BASE}/routes/sheep_goats_date_paid`

export const DEDUP_CANDIDATES_URL = `${BASE}/routes/dedup_candidates`
export const DEDUP_MERGE_URL = `${BASE}/routes/dedup_merge`
export const DEDUP_UNMERGE_URL = `${BASE}/routes/dedup_unmerge`
export const DEDUP_NOT_DUPLICATE_URL = `${BASE}/routes/dedup_not_duplicate`
export const DEDUP_HISTORY_URL = `${BASE}/routes/dedup_history`
